import { darkTheme, msToSecondsInTime, useIntl } from '@capsicum/common';
import { Chip } from '@capsicum/common-web';
import { FeedFiltersType, LOADER_ACTIVTIES_INTERVAL, useLoaderActivities } from '@capsicum/socios-core';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';

import { usePostFiltersChips } from '../hooks/usePostFiltersChips';

export const LoaderActivities = () => {
	const { filterChips } = usePostFiltersChips({
		filterChipsByPredicate: () => true,
		type: FeedFiltersType.FOLLOWED_TEAMS
	});
	const { chips, currentChip, setCurrentChipIndex } = useLoaderActivities(filterChips);
	const { $t } = useIntl();

	const { iconStart, name, value } = currentChip;

	return (
		<>
			<S.Container animate={{ opacity: 1 }} as={motion.div} initial={{ opacity: 0 }}></S.Container>
			<S.Wrapper>
				<S.ChipContainer>
					<AnimatePresence mode="wait">
						<motion.div
							animate={{ opacity: 1 }}
							key={value}
							transition={{
								duration: msToSecondsInTime(LOADER_ACTIVTIES_INTERVAL),
								ease: 'linear'
							}}
							onAnimationComplete={() => setCurrentChipIndex(prev => (prev + 1) % chips.length)}
						>
							<Chip iconStart={iconStart} text={name} value={value} variant="backgroundBright" />
						</motion.div>
					</AnimatePresence>
				</S.ChipContainer>
				<S.StyledText>{$t('feed.loaders.activitiesWaitingText')}</S.StyledText>
			</S.Wrapper>
		</>
	);
};

namespace S {
	export const Wrapper = styled.div`
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.medium};
		z-index: 100;
		user-select: none;
		cursor: default;
	`;

	export const Container = styled(Wrapper)`
		background-color: ${darkTheme.colors.common.scrim.background};
	`;

	export const ChipContainer = styled(motion.div)`
		pointer-events: none;
	`;

	export const StyledText = styled.p`
		display: flex;
		justify-content: center;
		align-items: center;
		${({ theme }) => theme.fonts.text.text1};
		color: ${() => darkTheme.colors.text.main.enabled};
	`;
}
